if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        if (this.isCompareBarShowing()) {
          this.hide();
        } else {
          this.show();
        }

        this.lastScrollTop = 0;
        this.scrollDirection = undefined;
        this.scrollFrame = undefined;
        this.mobileNavStatic = document.getElementById('mobileNavStatic');
        this.init();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);

        if (this.scrollFrame !== undefined) {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = undefined;
        }

        if (this.heightFrame !== undefined) {
          cancelAnimationFrame(this.heightFrame);
          this.heightFrame = undefined;
        }

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }

        if (this.bottomObserver) {
          this.bottomObserver.disconnect();
        }

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
      }

      init() {
        this.initHeightObserver();
        this.initBottomObserver();
        this.scrollHandler = this.onScrollHandler.bind(this);
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
      }

      initHeightObserver() {
        if (typeof ResizeObserver === 'undefined') {
          this.calculateHeight();
          return;
        }

        this.resizeObserver = new ResizeObserver((entries) => {
          const entry = entries[0];
          const borderBoxSize = Array.isArray(entry.borderBoxSize) ? entry.borderBoxSize[0] : entry.borderBoxSize;
          const observedHeight = borderBoxSize && Number.isFinite(borderBoxSize.blockSize)
            ? borderBoxSize.blockSize
            : this.offsetHeight;

          this.updateHeight(observedHeight);
        });
        this.resizeObserver.observe(this);
      }

      calculateHeight() {
        this.heightFrame = requestAnimationFrame(() => {
          this.heightFrame = undefined;
          this.updateHeight(this.offsetHeight);
        });
      }

      updateHeight(height) {
        const roundedHeight = Math.round(height);
        if (this.mobileStickyBarHeight === roundedHeight) return;

        this.mobileStickyBarHeight = roundedHeight;
        document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${roundedHeight}px`);
      }

      initBottomObserver() {
        this.isBottomMarkerVisible = false;

        if (!this.mobileNavStatic || typeof IntersectionObserver === 'undefined') return;

        this.bottomObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.isBottomMarkerVisible = Boolean(entry && entry.isIntersecting);

          if (this.isCompareBarShowing() || this.isBottomMarkerVisible) {
            this.hide();
          } else if (this.scrollDirection === 'up') {
            this.show();
          }
        });
        this.bottomObserver.observe(this.mobileNavStatic);
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      onScrollHandler() {
        if (this.scrollFrame !== undefined) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = undefined;
          this.updateScrollState();
        });
      }

      updateScrollState() {
        if (this.isCompareBarShowing()) {
          this.hide();
          return;
        }

        const scrollTop = window.scrollY;
        this.scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';
        this.lastScrollTop = scrollTop;

        let isBottomMarkerVisible = this.isBottomMarkerVisible;
        if (!this.bottomObserver && this.mobileNavStatic) {
          const pointTouch = this.mobileNavStatic.offsetTop - scrollTop - window.innerHeight;
          isBottomMarkerVisible = pointTouch <= 0;
        }

        if (this.scrollDirection === 'up' && !isBottomMarkerVisible) {
          this.show();
        } else {
          this.hide();
        }
      }

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        document.body.classList.remove(this.classes.isShow);
        document.body.classList.add(this.classes.isHide);
      }
    }
  );
}
